import React, { ChangeEvent, memo } from 'react';
import * as Styled from './styled';

interface ReportDateProps {
  placeholder: string;
  name: string;
  mask: (string | RegExp)[];
  value: string;
  error?: string;
  label?: string;
  required?: boolean;
  className?: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const ReportSettingReportDateInput = memo(
  ({
    placeholder,
    name,
    mask,
    value,
    error,
    label,
    required,
    className,
    onChange,
  }: ReportDateProps): JSX.Element => {
    return (
      <div className={className}>
        <Styled.ReportDateInput
          label={label}
          placeholder={placeholder}
          name={name}
          value={value}
          onChange={onChange}
          mask={mask}
          required={required}
          hasError={!!error}
        />
        {error && <div className="dateError">{error}</div>}
      </div>
    );
  },
);
